import { Theme, alpha } from "@mui/material/styles";

export const AvatarStyle = (theme: Theme, color: string) => ({
    width: 40,
    height: 40,
    border: `2px solid ${alpha(color, 0.5)}`,
    backgroundColor: alpha(color, 0.12),
    color,
    fontWeight: 500,
});